<template>
    <v-container>
        <v-snackbar
        v-model="snackbar" right top :timeout="timeout"
        > 
            {{ text }}
            <v-btn color="error" flat @click="snackbar = false" >
                Fechar
            </v-btn>
        </v-snackbar>


        <v-form>
                <v-text-field v-model="user.email" label="Email" ></v-text-field>
                <v-text-field v-model="user.password" type="password" label="Senha" ></v-text-field>
                <v-checkbox
                    v-model="keepLogged"
                    label="Continuar conectado"
                ></v-checkbox>
                <v-btn :loading="!loaded" @click="login">Entrar</v-btn>
        </v-form>
    </v-container>
</template>

<script>
import base from '../plugins/firebase'
import firebase from 'firebase';

export default {
    data() {
        return {
            user: {
                email: '',
                password: ''
            },
            snackbar: false,
            timeout: 3000,
            text: '',    
            keepLogged: false,
            loaded: true,
            

            dismissSecs: 5,
            dismissCountDown: 0

        }
    },

    mounted() {
        window.addEventListener("keypress", e => {
            // enter key
            if(e.keyCode === 13){
                this.login()
            };
        });
    },

    methods: {
        countDownChanged(dismissCountDown) {
            this.dismissCountDown = dismissCountDown
        },

        showAlert() {
            this.dismissCountDown = this.dismissSecs
        },

        handleError(err) {
            if (err.code == 'auth/invalid-email' || err.code == 'auth/user-not-found') {
                this.text = 'Email incorreto'
            }
            else if (err.code == 'auth/wrong-password') {
                this.text = 'Senha incorreta'
            }
            else{
                this.text = 'Erro na autenticação.'
            }

            this.snackbar = true
        },

        login() {
            if(this.user.email.trim() != '' && this.user.password.trim() != '') {
                this.loaded = false
                if(this.keepLogged){
                    base.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL).then( () => {
                        base.auth().signInWithEmailAndPassword(this.user.email, this.user.password)
                        .then(res => {
                            this.$router.push({ path: '/admin' })
                            this.loaded = true

                        }, err => {
                            this.handleError(err)
                            this.loaded = true
                        })
                    })
                }
                else{
                    base.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION).then( () => {
                        base.auth().signInWithEmailAndPassword(this.user.email, this.user.password)
                        .then(res => {
                            this.$router.push({ path: '/admin' })
                            this.loaded = true
                        }, err => {
                            this.handleError(err)
                            this.loaded = true
                        })
                    })
                }
            }
            else {
                if(this.user.email.trim() == ''){
                    this.text = 'Campo de email vazio',
                    this.snackbar = true
                }
                else {
                    this.text = 'Campo da senha está vazio',
                    this.snackbar = true
                }
            }
        }
    }

}
</script>

<style>

</style>
